import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import {
  BlacklistAction,
  ISingleCandidate,
  IUpdateCandidateBody,
} from "./types";
import { SortingTypes } from "../../helpers/SortingTypes";
import { IVacancyApplication } from "../vacancyApplications/types";

export const getCandidates = (
  search?: string,
  params?: {
    limit: number;
    offset: number;
    sort_column?: string;
    sort_direction?: SortingTypes;
    created_at_from?: string;
    created_at_to?: string;
    channel_id?: number;
    department_id?: number;
    skill?: string[];
    source_id?: number;
    status?: string;
    created_by?: number;
    responsible_recruiter_id?: number;
  }
): AxiosPromise<{ count: number; items: ISingleCandidate[] }> => {
  return axiosInstance.get(
    `/candidates?expand=name,expected_position,skills,status,created_at,created_by, sort_fields,contact_telegram, source&limit=${
      params?.limit
    }&offset=${params?.offset}${
      search !== "" && search !== undefined ? `&search=${search}` : ""
    }${params?.sort_column ? `&sort_column=${params?.sort_column}` : ""}${
      params?.sort_direction ? `&sort_direction=${params?.sort_direction}` : ""
    }${params?.channel_id ? `&channel_id=${params?.channel_id}` : ""}${
      params?.department_id ? `&department_id=${params?.department_id}` : ""
    }${
      params?.skill && params?.skill.length > 0
        ? params?.skill.map((skillId) => `&skill[]=${skillId}`).join("")
        : ""
    }${params?.source_id ? `&source_id=${params?.source_id}` : ""}${
      params?.status ? `&status=${params?.status}` : ""
    }${params?.created_by ? `&created_by=${params?.created_by}` : ""}${
      params?.created_at_from
        ? `&created_at_from=${params?.created_at_from}`
        : ""
    }${params?.created_at_to ? `&created_at_to=${params?.created_at_to}` : ""}${params?.responsible_recruiter_id ? `&responsible_recruiter_id=${params?.responsible_recruiter_id}` : ""}`
  );
};

export const getCandidatesByVacancy = (
  id: string,
  params?: { sort_column?: string; sort_direction?: SortingTypes }
): AxiosPromise<IVacancyApplication[]> =>
  axiosInstance.get(
    `/vacancy-applications?expand=candidate.internal_rate,candidate.source,created_by,created_at,interview_at&vacancy_id=${id}${
      params?.sort_column ? `&sort_column=${params?.sort_column}` : ""
    }${
      params?.sort_direction ? `&sort_direction=${params?.sort_direction}` : ""
    }`
  );

export const getSingleCandidate = (
  id: number
): AxiosPromise<ISingleCandidate> =>
  axiosInstance.get(
    `/candidate/${id}/view?expand=name,attachments,url,contacts,internal_rate,vacancy_applications.vacancy,vacancy_applications.created_by,expected_position,expected_salary,grade,country,town,contact_email,contact_email,contact_telegram,contact_phone,contact_whatsapp,birthday,source,comments,created_at,created_by,status, skills, vacancy_applications.created_at,activities,department,channel`
  );

export const createCandidate = (
  params: IUpdateCandidateBody
): AxiosPromise<ISingleCandidate> =>
  axiosInstance.post(`/candidate/create`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const updateCandidate = (
  id: number,
  params: IUpdateCandidateBody
): AxiosPromise<ISingleCandidate> =>
  axiosInstance.post(`/candidate/${id}/update`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const deleteCandidate = (id: number): AxiosPromise<undefined> =>
  axiosInstance.post(`/candidate/${id}/delete`);

export const candidateBlacklist = (
  id: number,
  params: { action: BlacklistAction }
): AxiosPromise<undefined> =>
  axiosInstance.post(`/candidate/${id}/black-list`, params);
